// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c2fdcce0","977":"76661bfe"}[chunkId] + ".chunk.js";
};